import { TAB_CONSTANTS } from './tab-constants';
var TabFoundation = /** @class */ (function () {
    function TabFoundation(_adapter) {
        var _this = this;
        this._adapter = _adapter;
        this._disabled = false;
        this._active = false;
        this._stretch = false;
        this._focusOnActivate = true;
        this._clickListener = function (evt) { return _this._onClick(evt); };
        this._mousedownListener = function (evt) { return _this._onMouseDown(evt); };
    }
    TabFoundation.prototype.initialize = function () {
        this._adapter.initialize();
        this._adapter.initializeRipple();
        this._adapter.initializeIndicator();
        this._adapter.setDisabled(this._disabled);
        this._setActive(this._active);
        this._adapter.addButtonListener('click', this._clickListener);
        this._adapter.addButtonListener('mousedown', this._mousedownListener);
    };
    TabFoundation.prototype.disconnect = function () {
        this._adapter.destroyRipple();
        this._adapter.destroyIndicator();
        this._adapter.removeButtonListener('click', this._clickListener);
        this._adapter.removeButtonListener('mousedown', this._mousedownListener);
    };
    TabFoundation.prototype._onClick = function (evt) {
        if (!this._active) {
            this._adapter.emitHostEvent(TAB_CONSTANTS.events.INTERACTED, null, true);
        }
    };
    TabFoundation.prototype._onMouseDown = function (evt) {
        if (!this._focusOnActivate) {
            evt.preventDefault();
        }
    };
    TabFoundation.prototype._setActive = function (isActive, previousIndicatorClientRect) {
        this._active = isActive;
        this._adapter.setActive(this._active);
        if (this._active) {
            this._adapter.activateIndicator(previousIndicatorClientRect);
        }
        else {
            this._adapter.deactivateIndicator();
        }
    };
    TabFoundation.prototype.activate = function (previousIndicatorClientRect) {
        this._setActive(true, previousIndicatorClientRect);
    };
    TabFoundation.prototype.deactivate = function () {
        this._setActive(false);
    };
    TabFoundation.prototype.computeIndicatorBounds = function () {
        return this._adapter.computeIndicatorBounds();
    };
    TabFoundation.prototype.computeDimensions = function () {
        var rootWidth = this._adapter.getOffsetWidth();
        var rootLeft = this._adapter.getOffsetLeft();
        var contentWidth = this._adapter.getContentOffsetWidth();
        var contentLeft = this._adapter.getContentOffsetLeft();
        return {
            contentLeft: rootLeft + contentLeft,
            contentRight: rootLeft + contentLeft + contentWidth,
            rootLeft: rootLeft,
            rootRight: rootLeft + rootWidth,
        };
    };
    TabFoundation.prototype.focus = function () {
        this._adapter.focus();
    };
    TabFoundation.prototype.setTabIndex = function (value) {
        this._adapter.setTabIndex(value);
    };
    Object.defineProperty(TabFoundation.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (value) {
            if (this._disabled !== value) {
                this._disabled = value;
                this._adapter.setDisabled(this._disabled);
                this._adapter.toggleHostAttribute(TAB_CONSTANTS.attributes.DISABLED, this._disabled);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabFoundation.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            if (this._active !== value) {
                this._setActive(value);
                this._adapter.toggleHostAttribute(TAB_CONSTANTS.attributes.ACTIVE, this._active);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabFoundation.prototype, "stretch", {
        get: function () {
            return this._stretch;
        },
        set: function (value) {
            if (this._stretch !== value) {
                this._stretch = value;
                this._adapter.toggleHostAttribute(TAB_CONSTANTS.attributes.STRETCH, this._stretch);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TabFoundation.prototype, "focusOnActivate", {
        get: function () {
            return this._focusOnActivate;
        },
        set: function (value) {
            if (this._focusOnActivate !== value) {
                this._focusOnActivate = value;
                this._adapter.setHostAttribute(TAB_CONSTANTS.attributes.FOCUS_ON_ACTIVATE, this._focusOnActivate.toString());
            }
        },
        enumerable: true,
        configurable: true
    });
    return TabFoundation;
}());
export { TabFoundation };
